module.exports = __webpack_public_path__ + "static/media/color-wheel.238f318f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/color-wheel.png
// module id = 2311
// module chunks = 0